// extracted by mini-css-extract-plugin
export var container = "AccountDetailsPage_container__Mk30a";
export var header = "AccountDetailsPage_header__NLaEl";
export var lg = "992px";
export var md = "768px";
export var sectionContainer = "AccountDetailsPage_sectionContainer__jE0En";
export var sectionContainerTitle = "AccountDetailsPage_sectionContainerTitle__AJAhW";
export var shared = "\"../shared.module.css\"";
export var tooltip = "AccountDetailsPage_tooltip__qzlCa";